import React from "react";
import Navbar from "../../Components/TopNavbar";
import Footer from "../../Components/Footer";

const ProductManagement = () => {
  return (
    <>
      <Navbar />
      <div>ProductManagement Course</div>
      <Footer />
    </>
  );
};

export default ProductManagement;
